import $ from 'jquery'

Ready(function() {
  // unlock form submit button when confirm input filled
  if($('body#users_merge').length > 0) {
    $('input#user_merge_confirm').keyup(function() {
      if ($(this).val() == 'MERGE') {
        $(this).closest('form').find(':submit').prop('disabled', false)
      } else {
        $(this).closest('form').find(':submit').prop('disabled', true)
      }
    })
  }
})
